import { Inject, Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    private _storage: Storage | null = null;

    constructor(@Inject(Storage) private storage: Storage) {
        this.init();
    }

    async init() {
        const storage = await this.storage.create();
        this._storage = storage;
    }

    public set(key: string, value: any): Promise<any> {
        if(this._storage)
            return this._storage?.set(key, value);
        else
            return new Promise(async (resolve) => {
                await this.init()
                this._storage?.set(key, value).then(resolve)
            })
    }

    public get(key: string): Promise<any> {
        if(this._storage)
            return this._storage?.get(key);
        else
            return new Promise(async (resolve) => {
                await this.init()
                this._storage?.get(key).then(v => resolve(v))
            });
    }

    public del(key: string): Promise<any> {
        if(this._storage)
            return this._storage?.remove(key);
        else
            return new Promise(async (resolve) => {
                await this.init()
                this._storage?.remove(key).then(v => resolve(v))
            });
    }

    public clear() : Promise<any>{
        if(this._storage)
            return this._storage?.clear();
        else
            return new Promise(async (resolve) => {
                await this.init()
                this._storage?.clear().then(resolve)
            });
    }

}
